import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminUserSubscriptionPage } from './admin-user-subscription';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminUserSubscriptionPage],
    imports: [PagesModule, ComponentsModule]
})
export class AdminUserSubscriptionPageModule { }
